// TODO: fetch this data from CMS
export const LOCALES = ["en"];
export const DEFAULT_LOCALE = "en";
